import { SelectOption } from '@/classes/SelectOption';

export function keyFrom(enumeration: Record<string, string | number>, searchedValue: unknown): string | null {
  const [key = null] = Object.entries(enumeration)
    .find(([, value]) => value === searchedValue) ?? [];
  return key;
}

export function allKeysFrom(enumeration: Record<string, string | number>): string[] {
  return Object.keys(enumeration)
    .filter(key => !Number(key));
}

export function createSelectOptionsFrom(enumeration: Record<string, string | number>): SelectOption[] {
  return allKeysFrom(enumeration)
    .map((enumKey) => new SelectOption(enumKey, enumeration[enumKey], enumKey));
}
